import { render } from "./ConfirmDelete.vue?vue&type=template&id=128c6ab8&scoped=true"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"

import "./ConfirmDelete.vue?vue&type=style&index=0&id=128c6ab8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128c6ab8"]])

export default __exports__